import { getPending as getBlackListPending } from 'shared/Modals/ClientBlackListModal'
import { getPending as getWatchlistPending } from 'shared/Modals/ClientWatchlistModal'

export const getGridLoading = (state) => getBlackListPending(state) || getWatchlistPending(state)
